<template>
  <div class="walkin">
    <v-head></v-head>
    <div class="walkin_content">
      <div class="walkin_content_one">
        <span>
          <a v-link="{path:'/broadcast'}"><img src="../../../static/images/walkin_1.jpg" alt=""></a>
         </span>
        <span>
             <a v-link="{path:'/contactus'}"><img :src="walkin_us.image" alt=""></a>
         </span>
      </div>
      <div class="walkin_content_two">
         <span>
           <a v-link="{path:'/introduction'}"><img :src="walkin_tips.image" alt=""></a>
         </span>
        <span>
           <a v-link="{path:'/brandmark'}"><img :src="walkin_contant.image" alt=""></a>
         </span>
      </div>
      <div class="walkin_content_tre">
        <a v-link="{path:'/crossover'}"><img src="../../../static/images/walkin_5.jpg" alt=""></a>
      </div>
    </div>
    <v-footer></v-footer>

  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          url:"http://112.74.184.45:882/",
          walkin_list:{
            walkin_left_top:"",
            walkin_left_bottom:"",
            walkin_middle_top:"",
            walkin_middle_bottom:"",
            walkin_bottom:"",
          },
          walkin_contant:{},
          walkin_us:{},
          walkin_tips:{}


      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      /*$.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getNewsByTypeId/typeId/90",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
              console.log(999888,data);
            for(var i = 0;i<data.data.length;i++){
              _this.walkin_list.walkin_left_top = _this.url + data.data[2].src;
              _this.walkin_list.walkin_left_bottom = _this.url + data.data[3].src;
              _this.walkin_list.walkin_middle_top = _this.url + data.data[0].src;
              _this.walkin_list.walkin_middle_bottom = _this.url + data.data[1].src;
              _this.walkin_list.walkin_bottom = _this.url + data.data[4].src;
            }
          }
        },
      });*/
      $.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getNewsById/276",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222,data)
            _this.walkin_contant = data;
          }
        },
      });
      $.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getNewsById/275",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222,data)
            _this.walkin_us = data;
          }
        },
      });
      $.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getNewsById/273",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222,data)
            _this.walkin_tips = data;
          }
        },
      });
    }
  }
</script>

<style>
  .walkin{width: 9rem;margin: 0 auto;}
  /*.walkin_content_one{  -moz-column-count:2; !* Firefox *!  -webkit-column-count:2; !* Safari 和 Chrome *!  column-count:2;  -moz-column-gap:0.05rem;  -webkit-column-gap:0.05rem;  column-gap:0.05rem;-moz-column-width: 4.4rem;  -webkit-column-width:4.4rem;  column-width:4.4rem;-webkit-column-break-inside: avoid;  page-break-inside: avoid;  break-inside: avoid; }*/
  .walkin_content{width:9rem;margin-top: 0.5rem}
  .walkin_content div:first-child{float: left;width: 4.45rem}
  .walkin_content div:last-child{width: 100%}
  .walkin_content img{width: 100%}
  .walkin_content_two{width:4.45rem;float: right;}
  .walkin_content_two span{width: 4.45rem;display: inline-block;margin-bottom: 0.05rem}
  .walkin_content_one span{display: inline-block;margin-bottom: 0.05rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .walkin{width: 100%;overflow: auto}
    .walkin_content{width: 100%;}
    .walkin_content div:first-child{width: 100%}
    .walkin_content div:last-child{width: 100%}
    .walkin_content img{width: 100%}
    .walkin_content_two{width:100%;}
    .walkin_content_two span{width:100%}

  }
</style>



// WEBPACK FOOTER //
// walkin.vue?0510f6be